import { handleBootErrorForMini } from 'mini-auth-error-handler/lib/handleBootErrorForMini';
import { mailStart } from './mailStart';

mailStart({ handleBootError: handleBootErrorForMini });
